module.exports = __webpack_public_path__ + "static/media/blackboard.3c0ccd91.JPG";